import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

const STORAGE_KEY = 'kickstats_gestao_dock_v1';

function loadState() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { open: false, collapsed: false };
    const p = JSON.parse(raw);
    return {
      open: Boolean(p.open),
      collapsed: Boolean(p.collapsed),
    };
  } catch {
    return { open: false, collapsed: false };
  }
}

const GestaoDockContext = createContext(null);

export function GestaoDockProvider({ children }) {
  const [state, setState] = useState(loadState);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch {
      /* ignore */
    }
  }, [state]);

  const openDock = useCallback(() => {
    setState((s) => ({ ...s, open: true, collapsed: false }));
  }, []);

  const closeDock = useCallback(() => {
    setState((s) => ({ ...s, open: false }));
  }, []);

  const toggleDock = useCallback(() => {
    setState((s) => ({ ...s, open: !s.open, collapsed: false }));
  }, []);

  const toggleCollapsed = useCallback(() => {
    setState((s) => ({ ...s, collapsed: !s.collapsed }));
  }, []);

  const value = useMemo(
    () => ({
      ...state,
      openDock,
      closeDock,
      toggleDock,
      toggleCollapsed,
    }),
    [state, openDock, closeDock, toggleDock, toggleCollapsed],
  );

  return (
    <GestaoDockContext.Provider value={value}>
      {children}
    </GestaoDockContext.Provider>
  );
}

export function useGestaoDock() {
  const ctx = useContext(GestaoDockContext);
  if (!ctx) {
    throw new Error('useGestaoDock must be used within GestaoDockProvider');
  }
  return ctx;
}
